import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Outlet, useLocation, useNavigate } from 'react-router-dom'; // Importez useLocation et useNavigate

const UserProfile = () => {
    const { user } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('');

    useEffect(() => {
        // Met à jour l'onglet actif en fonction de la route actuelle
        if (location.pathname.includes('commandes')) {
            setActiveTab('orders');
        } else if (location.pathname.includes('info')) {
            setActiveTab('info');
        } else if (location.pathname.includes('parametres')) {
            setActiveTab('settings');
        } else if (location.pathname.includes('transactions')) {
            setActiveTab('transactions');
        }
    }, [location.pathname]);

    const initials = `${user.firstname.charAt(0)}${user.lastname.charAt(0)}`;

    return (
        <div className="max-w-5xl mx-auto p-6">
            <div className="flex items-center gap-x-4 mb-6">
                <div className="w-16 h-16 bg-primary text-primary-content rounded-full flex items-center justify-center text-2xl font-semibold">
                    {initials}
                </div>
                <div>
                    <h1 className="text-2xl font-bold">{user.firstname} {user.lastname}</h1>
                    <p className="text-base-content/70">{user.email}</p>
                </div>
            </div>
            <div className="flex gap-x-2 border-b border-base-300 pb-2 mb-4">
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'orders' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('commandes')}
                >
                    Commandes
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'transactions' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('transactions')}
                >
                    Transactions
                </button>
                <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'info' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('informations')}
                >
                    Informations
                </button>
                {/* <button
                    className={`px-4 py-2 btn btn-primary ${activeTab === 'settings' ? '' : 'btn-outline border-solid border-primary'}`}
                    onClick={() => navigate('parametres')}
                >
                    Paramètres
                </button> */}
            </div>
            <div>
                <Outlet /> {/* Utilisez Outlet pour rendre les routes enfants */}
            </div>
        </div>
    );
};

export default UserProfile;
